import React, { memo } from 'react';

export const MEMBER_COLOR = '#F59E0B';

interface IMemberBadgeProps {
  size?: number;
  className?: string;
}

/** Huy hiệu hội viên kênh: ngôi sao trong khiên, một màu duy nhất ở mọi nơi. */
const MemberBadge: React.FC<IMemberBadgeProps> = ({ size = 16, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Hội viên kênh"
    className={className}
  >
    <title>Hội viên kênh</title>
    <path
      d="M8 .8 14 3v4.6c0 3.4-2.4 6.1-6 7.6-3.6-1.5-6-4.2-6-7.6V3L8 .8Z"
      className="fill-[#F59E0B]"
    />
    <path
      d="m8 4.3 1.05 2.15 2.35.34-1.7 1.66.4 2.35L8 9.6l-2.1 1.2.4-2.35-1.7-1.66 2.35-.34L8 4.3Z"
      className="fill-white"
    />
  </svg>
);

export default memo(MemberBadge);
